import React, { Component } from "react";
import { Link } from "gatsby";
import Layout from "./layout";
import "../css/style.css"

class ProgramStrutcurePG extends Component {
  


render(){
  return(

                        <div>
                            <div class="campus-learning-inner">
                                <div class="text-box">
                                    <h3>Online Pre Masters Program (PMP)</h3>
                                    <p>The online PMP is brought to you by {this.props.Term1Info}. This program is designed to benefit students who do not meet the stringent admission criteria of a global masters degree program by reducing the entry requirements. The PMP builds foundational skills required for an overseas postgraduate degree and students completing the program are considered at par with direct admits. Each subject takes 7 weeks to complete and you can take on upto 2 subjects at a time thereby completing the program in 3.5 months. With our student friendly online focussed curriculum and award winning 1-1 tutor program you will be well on your way to your dream destination. Students completing the online PMP are guaranteed admission into the postgraduate degree chosen.
                                    </p>
                                
                                </div>
                                <div class="campus-learning-box">
                                {this.props.subjectInfo}    
                                </div>
                            </div>
                            <div class="campus-learning-inner">
                                <div class="text-box">
                                    <h3>On Campus Learning (Masters Program)</h3>
                                    <p>Upon completion of the online modules, you will progress to  {this.props.Term3Info} to begin your masters degree. The masters program offers you a number of core and elective modules based on your interest and desired specialisation. All students who complete the program qualify for post-study work-rights. 
                                    <br/><br/>Further details on the program structure, completion requirements and specialisations are available with our admissions team. 
</p>
                                </div> 
                            </div>
                        </div>
  )
}

}

export default ProgramStrutcurePG;